
<template>
<div class="helper-container">
  <el-tooltip v-model="tipVisible" :manual="tipControl" placement="bottom" effect="light">
    <div class="tip-wrap" slot="content">
      <label>Hi~,我是考网小助手，我可以提供帮助呦~，快点我吧!~~</label>
      <el-button style="margin-right:10px;margin-top:10px;" type="text" @click="handleTipClose" class="footer-btn">我知道了</el-button>
    </div>
    <i @click="openHelperDialog" style="font-size:28px;cursor: pointer;color:#469046;" class="iconfont icon-jiqiren"></i>
  </el-tooltip>
  <el-dialog
    title="考网小助手"
    :visible.sync="dialogVisible"
    width="555px"
    class="validate-dialog"
    :close-on-click-modal="false"
    :before-close="handleClose"
    @open="initDialog">
    <div style="display: flex;height: 300px;" class="dialog-panel">
      <div @click="openUrl('teacherVideo')" class="help-item">
        <i  style="color:#469046;font-size:50px;cursor: pointer;" class="iconfont icon-kehuguanli"></i>
        <span class="mobile-label">教师评卷教学</span>
      </div>
      <div  @click="openUrl('leaderVideo')" class="help-item">
        <i style="color:#469046;font-size:50px;cursor: pointer;" class="iconfont icon-laoshi"></i>
        <span class="mobile-label">组长评卷教学</span>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="info" @click="handleClose" class="footer-btn">关 闭</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
export default {
  name: 'KwHelper',
  data () {
    return {
      tipControl: true,
      // tipDisabled: false,
      tipVisible: true,
      dialogVisible: false
    }
  },
  props: {
    userInfo: {
      type: Object
    }
  },
  methods: {
    handleTipClose () {
      this.tipVisible = false
      this.tipDisabled = true
    },
    openHelperDialog () {
      this.dialogVisible = true
    },
    openUrl (type) {
      if (type === 'teacherVideo') {
        window.open('https://www.bilibili.com/video/BV1e64y1U7De')
      }
      if (type === 'leaderVideo') {
        window.open('https://www.bilibili.com/video/BV1pQ4y1Z7rR')
      }
    },
    handleClose () {
      this.dialogVisible = false
    },
    initDialog () {

    }
  }
}
</script>

<style lang="scss" scoped>
@media print {
  .helper-container{
    display: none;
  }
}
.tip-wrap{
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  height: 70px;
}
.helper-container {
  display: flex;
  width: 50px;
  justify-content: center;
  align-items: center;

}
.dialog-panel{
  .help-item{
    display: flex;
    height: 100px;
    width: 118px;
    flex-direction: column;
    justify-content: center;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/custom/KwHelper.vue